import React from "react";
import AddIcon from "@mui/icons-material/Add";
import useAuth from "src/hooks/useAuth";
import { allowedToCreateEntity } from "src/constants/role";
import Controls from "src/components/form/controls/Controls";
import { isOpenPopup } from "src/utils/isOpenPopup";

const IotCallingControlPanel = ({
  permissionsAccessControl,
  handleOpenPopup,
  children,
}) => {
  const { auth } = useAuth();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        {allowedToCreateEntity(auth?.permissions, permissionsAccessControl) && (
          <Controls.Button
            text="Add New"
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => handleOpenPopup(isOpenPopup, null)}
          />
        )}
      </div>
    </div>
  );
};

export default IotCallingControlPanel;
